import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e9c079d6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "urs-login"
};
const _hoisted_3 = {
  id: "mobileLogin",
  ref: "mobileLoginRef"
};
const _hoisted_4 = {
  class: "others-login"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "others-login-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "line"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "使用第三方登录"), /*#__PURE__*/_createElementVNode("div", {
  class: "line"
})], -1));
const _hoisted_6 = {
  class: "others-login-items"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "login-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "login-mask",
    onClick: _withModifiers($setup.onCloseClick, ["stop"])
  }, [_createElementVNode("div", {
    class: "login",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: "header-text"
  }, _toDisplayString($setup.header)), !$props.hideLoginBoxClose ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    class: "btn-close",
    href: "#",
    onClick: _withModifiers($setup.onCloseClick, ["prevent"])
  })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, null, 512)]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.otherLoginConfig, (item, index) => {
    return _createElementVNode("div", {
      key: item.alt,
      class: _normalizeClass(['other-login-item', index === $setup.otherLoginConfig.length - 1 ? 'other-login-last' : '']),
      onClick: $event => $setup.login(item.type)
    }, [_createElementVNode("div", {
      class: _normalizeClass(['login_btn', item.class])
    }, null, 2), _createElementVNode("span", _hoisted_8, _toDisplayString(item.name), 1)], 10, _hoisted_7);
  }), 64))])])])]);
}